export enum ServiceRequestStatus {
    open = 'open',
    inProgress = 'in_progress',
    onHold = 'on_hold',
    closed = 'closed',
    cancelled = 'cancelled',
    archived = 'archived',
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/service-request/service-request-status.ts